import React, { useEffect, useState } from "react";
import { errorMsg, successMsg } from "../../Toastify";
import { useSelector } from "react-redux";
import {
  CreateDesignationMaster,
  GetDesignationList,
  UpdateDesignationMaster,
} from "../../../Repository/Api";
import CustomModal from "../../CustomModal";
const itemsPerPage = 10;

const Designationmaster = () => {
          const { first_name, desingation, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const [designation, setDesignation] = useState([]);
  const [masterModel, setMasterModel] = useState(false);
  const [createDesignation, setCreateDesignation] = useState({});
  const [validation, setValidation] = useState({});
  const [dummyleaveList, setdummyLeaveList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchText, setSearchText] = useState('')
  

  const SearchfilteredData = dummyleaveList?.filter(item =>
    Object.values(item).some(value =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );
  useEffect(() => {
    if (searchText) {
      setDesignation(SearchfilteredData)
      setCurrentPage(1)
    } else {
      setDesignation(dummyleaveList)
    }
  }, [searchText, dummyleaveList])
  useEffect(() => {
    getDesignationList();
  },[]);

  const getDesignationList = async () => {
    const response = await GetDesignationList(token);
    if (response && response.statusCode === 200) {
      // setDesignation(response?.data?.designation);
      setdummyLeaveList(response?.data?.designation)
    } else {
      errorMsg(response.message);
    }
  };

  const setData = (e, key) => {
    let TempData = createDesignation;
    TempData[key] = e;
    setCreateDesignation(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!createDesignation.name) {
      validdateData.name = "Designation Name is Required";
      Status = false;
    }
    if (!createDesignation.officer_type) {
      validdateData.officer_type = "Officer Type is Required";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (CheckValidation()) {
      const Payload = {
        name: createDesignation.name,
        officer_type: createDesignation.officer_type,
      };
      const response = await CreateDesignationMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateDesignation({});
        setMasterModel(false);
        e.target.reset();
        getDesignationList();
      } else {
        errorMsg(response.message);
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (CheckValidation()) {
      const Payload = {
        id: createDesignation.id,
        name: createDesignation.name,
        officer_type: createDesignation.officer_type,
      };
      const response = await UpdateDesignationMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateDesignation({});
        setMasterModel(false);
        e.target.reset();
        getDesignationList();
      } else {
        errorMsg(response.message);
      }
    }
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = designation.slice(indexOfFirstItem, indexOfLastItem);
  
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div>
        <div className="row justify-content-center mt-3">
          <div className="col-lg-6">
            <div class="input-group flex-nowrap">
              <span class="input-group-text" id="addon-wrapping"><span class="material-symbols-outlined search-input-icon">search</span></span>
              <input type="text" class="form-control search-table-data"
                placeholder="Search"
                aria-describedby="addon-wrapping"
                name="search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>
          <button
            type="button"
            className="btn add-btn col-lg-2"

            onClick={() => setMasterModel(true)}
          >
            <span className="material-symbols-outlined align-middle iconsize">
              add_circle
            </span>
            <span className="align-middle"> Add</span>
          </button>
        </div>

        <div className="graphbox">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Designation Name</th>
                <th scope="col">Officer Type</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems &&
                currentItems.map((design, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td
                      className="namelink textformat"
                      onClick={() => {
                        setMasterModel(true);
                        setCreateDesignation(design);
                      }}
                    >
                      {design?.name}
                    </td>
                    <td className="textformat">
                      {design?.officer_type?.includes('_')
                        ? design?.officer_type?.replace(/_/g, " ")
                        : design?.officer_type}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td></td>
                  <td>
                    <div> No Data Found </div>
                  </td>
                  <td></td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4">
                  {/* <nav aria-label="...">
                    <ul className="pagination">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from({
                        length: Math.ceil(designation.length / itemsPerPage),
                      }).map((_, index) => (
                        <li
                          key={index}
                          className={`page-item ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          currentPage ===
                          Math.ceil(designation.length / itemsPerPage)
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav> */}
                  <nav aria-label="...">
                    <ul className="pagination">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from({
                        length: Math.ceil(designation.length / itemsPerPage),
                      }).map((_, index) => {
                        if (
                          index + 1 >= currentPage - 4 && // Display 4 pages before current page
                          index + 1 <= currentPage + 5 // Display 5 pages after current page
                        ) {
                          return (
                            <li
                              key={index}
                              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                            >
                              <button
                                className="page-link"
                                onClick={() => paginate(index + 1)}
                              >
                                {index + 1}
                              </button>
                            </li>
                          );
                        }
                        return null; // Hide pages outside the range
                      })}
                      <li
                        className={`page-item ${currentPage === Math.ceil(designation.length / itemsPerPage) ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* masterModel */}
      <CustomModal
        open={masterModel}
        onClickOutside={() => {
          setMasterModel(false);
          setCreateDesignation({});
        }}
      >
        <form
          onSubmit={(e) => {
            if (createDesignation.id) {
              handleUpdate(e);
            } else {
              handleSubmit(e);
            }
          }}
        >
          <div className="modal-content Modal-View m-auto">
            <div className="modalHeader text-center py-2">
              <h5 className="font-bold mt-2">
                {createDesignation.id ? "Update" : "Add New"}
                &nbsp;Designation Master
              </h5>
            </div>
            <div className="modal-body p-0 ">
              <div className="container">
                <div className="row d-flex align-items-center justify-content-center  mt-0">
                  <div className="container ">
                    <div className="row justify-content-center">
                      <div className="col-lg-8">
                        <div className=" my-5 px-3">
                          <div className="row justify-content-center mt-2">
                            <div className="col-lg-10">
                              <div className="mb-3">
                                <label className="labeltext">
                                  Name of the Designation:
                                </label>
                                <input
                                  type="text"
                                  className="fieldinput"
                                  placeholder="Enter Name of the Designation"
                                  defaultValue={createDesignation?.name}
                                  onChange={(e) => {
                                    setData(e.target.value, "name");
                                  }}
                                />
                                {validation.name && (
                                  <p className="validationerror">
                                    {validation.name}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <label className="labeltext">
                                  Officer Type:
                                </label>
                                <select
                                  className="fieldinput"
                                  defaultValue={createDesignation?.officer_type}
                                  onChange={(e) => {
                                    setData(e.target.value, "officer_type");
                                  }}
                                >
                                  <option value="">Select Officer Type</option>
                                  <option value="faculty">Faculty</option>
                                  <option value="supporting_staff">
                                    Supporting Staff
                                  </option>
                                  <option value="group_a_officer">
                                    Group A Officer
                                  </option>
                                </select>
                                {validation.officer_type && (
                                  <p className="validationerror">
                                    {validation.officer_type}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <div>
                <button
                  type="button"
                  className="btn mx-2 submit-btn"
                  onClick={() => {
                    setMasterModel(false);
                    setValidation({});
                    setCreateDesignation({});
                  }}
                >
                  Back
                </button>
              </div>
              <div>
                <button className="btn mx-2 submit-btn">
                  {createDesignation.id ? "Update" : "Create"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </CustomModal>
    </>
  );
};

export default Designationmaster;
